<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="sass">
.v-application 
  font-family: "Meiryo UI", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Yu Gothic UI", "MS PGothic", sans-serif !important
</style>

<style scoped>
.darkMode{
  background-color : "#1F1E30";
}

.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}

</style>
